<template>
  <div class="empty-shopping-cart">
    <img class="empty-shopping-cart-ico" src="../../assets/empty_shopping_cart_ico.png" alt="">
    <!-- <div class="text01">您尚未预订活动预定产品</div>
    <div class="text02">皇家加勒比游轮公司为您准备了多种活动预定产品</div>
    <van-button block class="btn-linear-gradient" @click="goNext">快速预订行前订活动产品</van-button> -->
    <div class="text01">您的购物车空空如也</div>
    <div class="text02">皇家行前订为您准备了丰富的船上娱乐餐饮活动</div>
    <van-button block class="btn-linear-gradient" @click="goNext">马上去看看</van-button>
  </div>
</template>

<script>
export default {
  methods: {
    goNext () {
      if (this.$store.getters.isLogin) {
        this.$router.push('/')
      } else {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.empty-shopping-cart{
  padding-top: 145px;
  font-size: 24px;
  text-align: center;
  color: @main-gray3;
  .text01{
    font-size: 30px;
    color: @main-gray1;
    margin-bottom: 10px
  }
  .text02{
    margin-bottom: 40px;
  }
  /deep/ .van-button--block{
    width: 60%;
    margin: 0 auto;
    color: @main-gray2;
  }
}
.empty-shopping-cart-ico{
  width: 176px;
  height: 150px;
  display: block;
  margin: 0 auto 30px;
}
</style>
